import { useMutation } from 'react-query';

import { type MutationFunction, useRequest } from '@frontend/api/src/common';

export type BulkCreateLineItemsData = {
  quoteItemIds: number[];
};

export type BulkCreateLineItemsLineItemData = {
  partNumber: string;
  revision?: string;
  description?: string;
  quantities?: string;
};

export type BulkCreateLineItemsVars = {
  quoteId: number;
  parts: BulkCreateLineItemsLineItemData[];
};

export const useBulkCreateLineItems: MutationFunction<
  BulkCreateLineItemsData,
  BulkCreateLineItemsVars
> = ({ requestOptions, queryOptions: mutationOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) => {
      const urlPath = `/quotes/${quoteId}/bulk_create_line_items`;

      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    {
      ...mutationOptions,
      mutationKey: ['quotes', 'bulkCreateLineItems'],
    },
  );
};
